/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamPracticeAvailabilityResponseData } from './genericApiResponseOralExamPracticeAvailabilityResponseData';
import type { GenericApiResponseOralExamPracticeAvailabilityResponseMessage } from './genericApiResponseOralExamPracticeAvailabilityResponseMessage';
import type { GenericApiResponseOralExamPracticeAvailabilityResponsePagination } from './genericApiResponseOralExamPracticeAvailabilityResponsePagination';
import type { GenericApiResponseOralExamPracticeAvailabilityResponseError } from './genericApiResponseOralExamPracticeAvailabilityResponseError';

export interface GenericApiResponseOralExamPracticeAvailabilityResponse {
  data?: GenericApiResponseOralExamPracticeAvailabilityResponseData;
  message?: GenericApiResponseOralExamPracticeAvailabilityResponseMessage;
  pagination?: GenericApiResponseOralExamPracticeAvailabilityResponsePagination;
  error?: GenericApiResponseOralExamPracticeAvailabilityResponseError;
  statusCode?: number;
}
